import './Terms.css';

export const Terms = ({
  color = 'white',
  showShareButtons = false,
  shareButtonsRedirect = false
}) => {
  const isWhite = color === 'white';

  const shareOnFacebook = () => {
    const urlToShare = 'http://thegiftofwhatif.com/';
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
  };

  const shareOnTwitter = () => {
    const shareText =
      'Holiday scratch-offs are the gift of "what if?" So stack as many gifts as you can for a chance to win scratch-offs!';
    const shareUrl = 'http://thegiftofwhatif.com/';
    const hashtags = 'HolidayGames,ScratchOffs,NorthCarolina';

    let twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}&hashtags=${hashtags}`;
    const imageURL =
      'https://papaya-madeleine-568dde.netlify.app/assets/social-share_v2.jpg';

    if (imageURL) {
      const fullText = shareText + imageURL;
      twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(fullText)}&url=${encodeURIComponent(shareUrl)}&hashtags=${hashtags}`;
    }

    window.open(twitterUrl, '_blank', 'width=600,height=400');
  };

  const redirectToFacebook = () => {
    window.open('https://www.facebook.com/nclottery', '_blank');
  };

  const redirectToTwitter = () => {
    window.open('https://x.com/nclottery', '_blank');
  };

  return (
    <div className='terms-container'>
      {showShareButtons && (
        <div
          style={{
            display: 'flex',
            gap: '10px',
            flexDirection: 'row',
            marginBottom: '15px'
          }}
        >
          <button
            className='share-icon-button'
            aria-label='Share on Facebook'
            type='button'
            onClick={
              !shareButtonsRedirect ? shareOnFacebook : redirectToFacebook
            }
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer'
            }}
          >
            <img
              className='share-icon'
              src={
                isWhite
                  ? '/assets/fb-white-icon.png'
                  : '/assets/fb-black-icon.png'
              }
              alt='https://www.facebook.com/nclottery'
              width='55'
            />
          </button>
          <button
            className='share-icon-button'
            aria-label='Share on X'
            type='button'
            onClick={!shareButtonsRedirect ? shareOnTwitter : redirectToTwitter}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer'
            }}
          >
            <img
              className='share-icon'
              src={
                isWhite
                  ? '/assets/x-white-icon.png'
                  : '/assets/x-black-icon.png '
              }
              alt='https://x.com/nclottery'
              width='55'
            />
          </button>
        </div>
      )}

      <span
        style={{ color: color, fontWeight: 'bold' }}
        className='terms-rules'
      >
        MUST BE 18 TO PLAY
      </span>
      <a
        href='/SM_2025_Dec_Skys_The_Limit_Social_Media_Promotion_Rules_120225.pdf'
        className='terms-rules'
        target='_blank'
        rel='noopener noreferrer'
        style={{ color: color }}
      >
        PROMOTION RULES
        <img
          className='snow-link-icon'
          src={
            isWhite
              ? '/assets/snowman-link-icon-white.png'
              : '/assets/snowman-link-icon.png'
          }
          alt='Snowman'
          width='10'
        />
      </a>
      <div className='space-5'></div>
      <div className='terms-row'>
        <img
          className='lotery-icon'
          src='/assets/lottery-icon.png'
          alt='lotery icon'
          width='100'
        />
        <span className='terms-and-conditions' style={{ color: color }}>
          MUST BE 18 TO PLAY. Approximate overall odds of winning a prize for
          Merry & Bright Blowout are 1 in 9.95. Approximate overall odds of
          winning, including breakeven prizes, for all remaining games range
          from 1 in 3.19 to 4.87. Approximate odds to win the top prizes range
          from 1 in 750 to 1,560,000. Odds to win the Merry Million Second
          Chance Promotion depend on the number of entries received. Problem
          Gambling Helpline: 877-718-5543.
        </span>
      </div>
    </div>
  );
};
